import React, { useState, useEffect } from 'react';
import { Button, Modal, Badge } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select from "react-select";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const DropStatus = ({ show, onClose, data, refresh }) => {
    
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [dataID, setDataID] = useState(data.sno);
    const [dropOption, setDropOption] = useState([]);
    const [reason, setReason] = useState(null);
    useEffect(() => {
        const fetchLeadSource = async () => {
            try {
                const response = await axios.get(`${baseURL}/dropdown/dropreason`);
                const formattedsource = response.data.data.map(item => ({
                    value: item.sno,
                    label: item.reason_name,
                }));
                setDropOption(formattedsource);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchLeadSource();
    }, []);

    const [single_day_cost, setcost] = useState(0);
    const [refundAmount, setRefundAmount] = useState(0);
    const [enterrefundamount, enterrefund] = useState(0);
    useEffect(() => {
        const fetchLeadSource = async () => {
            try {
                const response = await axios.get(`${baseURL}/dropdown/single_day_cost/${data.package}`);
                setcost(response.data.single_day_cost);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchLeadSource();
    }, []);

    useEffect(() => {
        if (single_day_cost !== 0 && data?.product_amount) {
            const usedAmount = Number(single_day_cost) * Number(data.delivered);
            const refund = Number(data.product_amount) - usedAmount;
            // console.log('refund: ',refund);
            setRefundAmount(refund > 0 ? refund : 0); // Avoid negative refund
            enterrefund(refund > 0 ? refund : 0); // Avoid negative refund
        } else {
            setRefundAmount(0);
            enterrefund(0);
        }
    }, [data, single_day_cost]);


    const [isChecked, setIsChecked] = useState(false);
    const handleCheckboxChange = (e) => {
        setIsChecked(e.target.checked);
    };

    const [isRefundChecked, setIsRefundChecked] = useState(false);

    useEffect (() => {
        if(data.payment_process !== 1){
            setIsRefundChecked(true);
        }
    }, [data]);

    const handleRefundCheckboxChange = (e) => {
        setIsRefundChecked(e.target.checked);
    };

    const [errors, setErrors] = useState({});
    const validate = () => {
        const newErrors = {};
        

        if (!reason) {
            newErrors.reson = "This Field is Required.";
        }

        return newErrors;
    };

    const user_id = parseInt(localStorage.getItem("user_id"), 10);
    const handleSubmit = (event) => {
        event.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        let refund = 0;
        if (isRefundChecked) {
            refund = 1;
        }

        const postData = { drop_reason: reason, refund: refund, refund_amount: enterrefundamount, updated_by: user_id };
        axios.put(`${baseURL}/leadsubscription/drop/${dataID}`, postData)
            .then(response => {
                onClose();
                refresh();
                toast.success("Subscription Droped Successfully!");
            }).catch(error => {
                onClose();
                console.log(error);
                toast.error("Subscription Drop Failed");
            });
    };

    
    return (
        <Modal show={show} size="md"  >
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Drop Product</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row mb-3 mt-3">
                        <div className="col-lg-12 mb-3">
                            <div className="d-flex justify-content-between">
                                <label className="text-black font-w500 fs-7">
                                    {isChecked ? 'Custom Reason' : 'Drop Reason'}<span className="required">*</span>
                                </label>
                                <label className="text-black font-w500 fs-7">
                                    <input
                                        type="checkbox"
                                        onChange={handleCheckboxChange}
                                        className="form-check-input me-2 mt-0 mb-2"
                                        id="customCheckBox1"
                                    />
                                    Custom Reason
                                </label>
                            </div>

                            {!isChecked ? (
                                <Select
                                    placeholder="Select Drop Reason"
                                    options={dropOption}
                                    onChange={(option) => {
                                        setReason(option.label);
                                    }}
                                />
                            ) : (
                                <textarea
                                    className="form-control"
                                    placeholder="Enter Drop Reason"
                                    onChange={(option) => {
                                        setReason(option.target.value);
                                    }}
                                />
                            )}
                            {errors.reson && <div className="text-danger fs-8 mt-1">{errors.reson}</div>}

                        </div>
                        {data.payment_process !== 1 && (

                            <div className='col-lg-6 mb-2'>
                                <div className="form-check custom-checkbox mt-3">
                                    <input
                                        type="checkbox"
                                        onChange={handleRefundCheckboxChange}
                                        className="form-check-input me-3"
                                        id="customCheckBox1"
                                        checked={isRefundChecked}
                                    />
                                    <h4 className='font-w600 text-black' htmlFor="customCheckBox1">Refund Eligible</h4>
                                </div>
                            </div>

                            
                        )}

                        {isRefundChecked && (
                            <>
                            <div className='row mb-2'>
                                <div className='col-lg-6 mb-2 d-flex flex-column gap-1'>
                                    <label className="text-black font-w500 fs-7">Paid Amount</label>
                                    <label className="text-danger font-w600 fs-6">₹ {Number(data.product_amount).toFixed(2)}</label>
                                </div>
                                <div className='col-lg-6 mb-2 d-flex flex-column gap-1'>
                                    <label className="text-black font-w500 fs-7">Delivered Days</label>
                                    <label className="text-danger font-w600 fs-6">{String(data.delivered).padStart(2, '0')}</label>
                                </div>
                                <div className='col-lg-6 mb-2 d-flex flex-column gap-1'>
                                    <label className="text-black font-w500 fs-7">Per Day Cost</label>
                                    <label className="text-danger font-w600 fs-6">{Number(single_day_cost).toFixed(2)}</label>
                                </div>
                                <div className='col-lg-6 mb-2 d-flex flex-column gap-1'>
                                    <label className="text-black font-w500 fs-7">Deducted Amount</label>
                                    <label className="text-danger font-w600 fs-6">₹ {(Number(single_day_cost) * Number(data.delivered)).toFixed(2)}</label>
                                </div>
                                <div className='col-lg-6 mb-2 d-flex flex-column gap-1'>
                                    <label className="text-black font-w500 fs-7">Eligible Amount</label>
                                    <label className="text-danger font-w600 fs-6">₹ {refundAmount.toFixed(2)}</label>
                                </div>
                                <div className='col-lg-6 mb-2 d-flex flex-column gap-1'>
                                    <label className="text-black font-w500 fs-7">Max Refund Days</label>
                                    <label className="text-danger font-w600 fs-6">2 Days</label>
                                </div>
                                <div className='col-lg-12 mb-2 d-flex flex-column gap-1'>
                                    <label className="text-black font-w500 fs-7">Refund Amount<span className='required'>*</span></label>
                                    <input type="text" className="form-control" placeholder="Enter Refund Amount" 
                                        value={enterrefundamount} 
                                        maxLength={10}
                                        onChange={(e) => {
                                            const onlyNums = e.target.value.replace(/[^0-9]/g, '');
                                            enterrefund(onlyNums);
                                        }}
                                    />
                                </div>
                            </div> 
                            </>
                        )}


                    </div>

                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4">
                        <Link className="btn btn-sm btn-primary" onClick={handleSubmit}>Yes, Drop It  <i className="fas fa-angle-double-right ms-2"></i></Link>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default DropStatus;
